import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import transportFavicon from './assets/transport-icon.png';

const ensureFavicon = (href) => {
  if (typeof document === 'undefined') return;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
};

ensureFavicon(transportFavicon);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);





